module.exports = __webpack_public_path__ + "static/media/sms-icon.6cbc07c1.svg";